<!-- Switch.svelte -->
<script lang="ts">
  export let isOn: boolean = false;
  export let title: string = "";
  export let onToggle: ((value: boolean) => void) | undefined = undefined;
  export let stylingClass: string | undefined = "";

  function toggle() {
    const newValue = !isOn;

    if (onToggle) {
      onToggle(newValue);
    }
  }
</script>

<button class="flex {stylingClass}" on:click={toggle}>
  <div class="switch">
    <div class={`circle ${isOn ? "on" : ""}`}></div>
  </div>

  {#if title}
    <div class="ml-4 text-gray-700">{title}</div>
  {/if}
</button>

<style lang="postcss" scoped>
  .switch {
    @apply inline-flex items-center h-[24px] w-[50px] bg-white rounded-full
      cursor-pointer border-2 border-[#c5dedb] hover:border-[#a4b9ba]
      transition-all duration-100;
  }

  /* Circle */
  .circle {
    @apply absolute h-[12px] w-[12px] bg-[#adc8c8] ml-[4px] rounded-full
      transition-all duration-100;
    transform: translateX(0);
  }

  /* Circle position when ON */
  .on {
    transform: translateX(200%) scale(130%);
    background-color: #67908a;
  }
</style>
